import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { change, initialize, submit } from 'redux-form';
import { PERMISSIONS, PERMISSION_ENTITIES, SUBSCRIPTION_TYPES } from '../../../_config/consts';
import { convertValueFromUnitToMinutes, convertValueFromUnitToSeconds, convertValueToNewTimeUnit } from '../../../_config/utils.js';
import AbilityProvider from '../../../permissionsUtils/AbilityProvider.js';
import * as ModalActions from '../../../redux/actions/modal.actions.js';
import * as SettingsActions from '../../../redux/actions/setting.actions';
import * as UserActions from '../../../redux/actions/user.actions.js';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import MDButton from '../../MDButton/MDButton.jsx';
import Permission from '../../Permission/Permission.jsx';
import SystemSettingsForm from '../../forms/SystemSettingsForm.jsx';


@connect((state) => ({ form: state.form.SystemSettingsForm, platformUsers: state.platformUsers }))
class SystemSettingsOperationalSection extends React.Component {


  async componentWillMount() {
    const { dispatch, setting } = this.props;
    dispatch(SettingsActions.fetchSettingsByType('systemSettings'))
    .then((response) => {
      let invitationLimit = 0;
      let guestInvitationLimitDefault = response.guestInvitationLimitDefault;
      if (response && response.guestInvitationLimitDefault && response.guestInvitationLimitDefault > 0) {
        invitationLimit = response.guestInvitationLimitDefault;
        guestInvitationLimitDefault = 1;
      }
      dispatch(initialize('SystemSettingsForm', {
        ...response,
        invitationLimit,
        guestInvitationLimitDefault,
        sessionTimeoutEnabled: response.sessionTimeoutSeconds > 0 ? 1 : 0,
        sessionTimeoutUnit: 'minutes',
        sessionTimeoutSeconds: convertValueFromUnitToMinutes(response.sessionTimeoutSeconds, 'seconds'),
      }));
    });
  }

  async saveCompanySettings(values) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      let sessionTimeoutSeconds = values.sessionTimeoutSeconds;
      try {
        sessionTimeoutSeconds = convertValueFromUnitToSeconds(values.sessionTimeoutSeconds, values.sessionTimeoutUnit);
      } catch (error) {
      }
      await dispatch(SettingsActions.updateSettings({ ...values, sessionTimeoutSeconds }));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="settingUpdateSuccessfully" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="settingUpdateError" /></h6>),
        },
      }));
    }
  }

  onSelectInvitationGuestOption(value) {
    const { dispatch } = this.props; 
    switch (value) {
      case 'DISABLED':
        dispatch(change('SystemSettingsForm', 'guestInvitationLimitDefault', 0));
        break;
      case 'ENABLED_NO_LIMIT':
        dispatch(change('SystemSettingsForm', 'guestInvitationLimitDefault', -1));
        break;
      case 'ENABLED_WITH_LIMIT':
        dispatch(change('SystemSettingsForm', 'guestInvitationLimitDefault', 1));
        break;
    }
  }

  onHandleChangeInvitationLimit(value) {
    const { dispatch } = this.props; 
    dispatch(change('SystemSettingsForm', 'guestInvitationLimitDefault', value));
  }

  onSelectSessionTimeoutOption(value) {
    const { dispatch } = this.props;
    if (value === 0) {
      dispatch(change('SystemSettingsForm', 'sessionTimeoutSeconds', 0));
    }
  }

  onSelectSessionTimeoutUnit(value) {
    const { dispatch, form } = this.props;
    const oldTimeUnit = form && form.values && form.values.sessionTimeoutUnit;
    if (oldTimeUnit) {
      const oldTimeValue = form && form.values && form.values.sessionTimeoutSeconds;
      if (oldTimeValue) {
        const newTimeValue = Math.ceil(convertValueToNewTimeUnit(oldTimeValue, oldTimeUnit, value));
        dispatch(change('SystemSettingsForm', 'sessionTimeoutSeconds', newTimeValue));
      }
    }
    dispatch(change('SystemSettingsForm', 'sessionTimeoutUnit', value));
  }

  async onSendTestEmail(values) {
    const { dispatch } = this.props;
    try {
      await dispatch(SettingsActions.sendTestEmail(values));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="testEmailSentSuccessfully" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="testEmailSentError" /></h6>),
        },
      }));
    }
  }

  render() {
    const { dispatch, form } = this.props;
    const isDeviceManagementActive = dispatch(UtilsActions.isDeviceManagementActive());
    const isInvitationActive = dispatch(UserActions.userHasSubscriptions(SUBSCRIPTION_TYPES.INVITATIONS));
    const { platformUsers: { data: { content: platformUsersData } } } = this.props;
    const defaultOption = { value: '', label: 'selectUserTag' };
    const usersMapped = _.map(platformUsersData, user => ({ value: user.email, label: `${user.firstname} ${user.lastname}  - ${user.email}` }));
    const usersOptions = [defaultOption, ...usersMapped];
    return (
      <div style={{ paddingLeft: 20, paddingRight: 25 }}>
        <SystemSettingsForm
          formValues={form}
          usersOptions={usersOptions}
          isDeviceManagementActive={isDeviceManagementActive}
          isInvitationActive={isInvitationActive}
          onSelectInvitationGuestOption={value => this.onSelectInvitationGuestOption(value)}
          onHandleChangeInvitationLimit={value => this.onHandleChangeInvitationLimit(value)}
          onSelectSessionTimeoutOption={value => this.onSelectSessionTimeoutOption(value)}
          onSelectSessionTimeoutUnit={value => this.onSelectSessionTimeoutUnit(value)}
          onSendTestEmail={values => this.onSendTestEmail(values)}
          onSubmit={values => this.saveCompanySettings(values)}
        />
        <div style={{ backgroundColor: 'white', position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}>
          <Permission do={[PERMISSIONS.UPDATE]} on={PERMISSION_ENTITIES.COMPANY} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MDButton
              containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
              style={{ height: 45, borderRadius: 0 }}
              title={<Entity entity="save" />}
              onClick={() => dispatch(submit('SystemSettingsForm'))}
            />
          </Permission>
          </div>
      </div>
    );
  }
} 

export default SystemSettingsOperationalSection;
